export const AppConfig = {
  base_url: process.env.REACT_APP_BASE_URL,
    access_token: process.env.REACT_APP_TOKEN,
};

